module.exports = __webpack_public_path__ + "static/media/SPOOKYSWAP-FTM-LQDR.a0123630.png";